export default __webpack_public_path__ + "static/media/09_HITACHI.f9a040c1.png";